import React, { useEffect, useState } from 'react';
import '../App.css';

/**
 * Themed prompt (replaces window.prompt). Single-line input + OK / Cancel.
 */
export default function PromptModal({
  isOpen,
  onClose,
  onSubmit,
  title = 'Enter value',
  label,
  placeholder = '',
  inputType = 'text',
  submitLabel = 'Submit',
  initialValue = ''
}) {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    if (isOpen) setValue(initialValue);
  }, [isOpen, initialValue]);

  useEffect(() => {
    if (!isOpen) return;
    const esc = (e) => e.key === 'Escape' && onClose?.();
    document.addEventListener('keydown', esc);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', esc);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const raw = value.trim();
    try {
      const result = onSubmit ? await Promise.resolve(onSubmit(raw)) : undefined;
      if (result !== false) onClose?.();
    } catch {
      /* Caller handles errors (e.g. toast); keep modal open */
    }
  };

  return (
    <div
      className="modal-overlay"
      onClick={(e) => e.target === e.currentTarget && onClose?.()}
      role="dialog"
      aria-modal="true"
      aria-labelledby="prompt-modal-title"
    >
      <div className="modal-panel" style={{ maxWidth: '440px' }}>
        <div className="modal-header">
          <h2 id="prompt-modal-title" className="modal-title">
            {title}
          </h2>
          <button type="button" className="modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <div className="modal-body">
          <form onSubmit={handleSubmit}>
            {label && (
              <label className="form-label" htmlFor="prompt-modal-input">
                {label}
              </label>
            )}
            <input
              id="prompt-modal-input"
              type={inputType}
              className="form-input"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              placeholder={placeholder}
              autoFocus
              step={inputType === 'number' ? '0.01' : undefined}
              min={inputType === 'number' ? '0' : undefined}
              style={{ marginBottom: '20px' }}
            />
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
              <button type="button" className="btn btn-outline" onClick={onClose}>
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                {submitLabel}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
